import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { AnalyticsInitializer } from '@core/services/core/analytics/analytics-initializer';
import { PoliciesDocumentsHelperService } from '@core/services/helpers/policies-documents-helper.service';
import { PolicyCardConfig } from '@models/policy-config';
import { spinner } from '@utils/rxjs';
import { switchMap } from 'rxjs/operators';
import { PaymentPlan } from 'src/app/core/models/payment-plan';
import { PolicyHealth } from 'src/app/core/models/policy-health';
import { ProductCard } from 'src/app/core/models/products';
import { ReceiptPaymentOrigin } from 'src/app/core/models/receipt';
import { AuthService } from 'src/app/core/services/core/auth/auth.service';
import { ContextService } from 'src/app/core/services/core/context.service';
import { NavigationHelper } from 'src/app/core/services/core/navigation-helper.service';
import { UiHelperService } from 'src/app/core/services/core/ui-helper.service';
import { FileHelperService } from 'src/app/core/services/helpers/file-helper.service';
import { PaymentPlanService } from 'src/app/core/services/http-services/payment-plan.service';
import { fromEntriesArr } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-payment-plan',
  templateUrl: './payment-plan.html',
  styleUrls: ['./payment-plan.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentPlanComponent implements OnInit {
  @Input() plan: PaymentPlan;
  @Input() set productCards(value: { [id: string]: ProductCard } ) {
    const productCards = this.proccessHealthCards(value);
    this._productCards = productCards;
  }
  @Input() set policiesCardsConfig(value: { [id: string]: PolicyCardConfig } ) {
    this._policiesCardsConfig = value;
  }
  _productCards: { [id: string]: ProductCard } = {};
  _policiesCardsConfig: { [id: string]: PolicyCardConfig } = {};
  hideCardDetail = true;
  changeCardDesign: boolean;

  constructor(
    private ui: UiHelperService,
    private fileHelper: FileHelperService,
    public paymentPlanService: PaymentPlanService,
    public ctx: ContextService,
    public nav: NavigationHelper,
    public auth: AuthService,
    private policiesDocumentsHelper: PoliciesDocumentsHelperService,
    private analyticsInitializer: AnalyticsInitializer
  ) {}

  ngOnInit() {
    this.changeCardDesign = this.breaksDesign(this.plan);
  }

  onBills() {
    this.analyticsInitializer.triggerManualClick(
      'page button',
      'click link',
      'justificantes anteriores'
    );
    const receipts = this.plan.receiptDocuments;
    this.nav.to(['payment-plan', this.plan.id, 'bills'], { receipts });
  }

  onPay() {
    this.analyticsInitializer.triggerManualClick(
      'page button',
      'click link',
      'pagar cuota'
    );
    const receiptList = this.plan.paymentPendingFees.map(fee => {
      fee.departmentType = 'PAYMENT_PLAN_FEE';
      return fee;
    });
    this.nav.to('receipt-payment/list', {
      paymentOrigin: ReceiptPaymentOrigin.APP,
      documentNumber:
        this.auth.getState().user && this.auth.getState().user.documentNumber,
      receiptList
    });
  }

  onShowMore() {
    this.hideCardDetail = !this.hideCardDetail;
  }

  getPaymentPlanDocument(documentType: 'contract' | 'summary' | 'receipt') {
    let id = '';
    switch (documentType) {
      case 'contract':
        if (this.plan.contractDocument) {
          id = this.plan.contractDocument.id;
        }
        break;
      case 'summary':
        if (this.plan.summaryDocument) {
          id = this.plan.summaryDocument.id;
        }
        break;
      case 'receipt':
        if (this.plan.lastReceiptDocument) {
          id = this.plan.lastReceiptDocument.id;
        }
        break;
      default:
        break;
    }

    if (!id) {
      this.policiesDocumentsHelper.handleDocumentError();
      return;
    }

    const params = {
      paymentPlanId: this.plan.id,
      id
    };

    const documentName = this.getDocumentTypeName(documentType);
    this.paymentPlanService
      .getPaymentPlansDocument(params, documentType)
      .pipe(
        spinner('payment-plan-list'),
        switchMap(file => {
          this.analyticsInitializer.triggerManualClick(
            'download',
            'pdf',
            `${documentName} - ${id}`
          );
          return this.fileHelper.open(file);
        })
      )
      .subscribe({
        error: (err) => this.policiesDocumentsHelper.handleDocumentError(err)
      });
  }

  private breaksDesign(plan: PaymentPlan): boolean {
    return (
      !plan.summaryDocument &&
      !plan.contractDocument &&
      !plan.lastReceiptDocument
    );
  }

  private proccessHealthCards(productCards: { [id: string]: ProductCard }) {
    if (!productCards) {
      return {};
    }
    const healthProductCardsWithTRONId = Object.entries(productCards)
      .filter(
        ([
          _,
          {
            policy: { policyBaseType }
          }
        ]) => policyBaseType === 'health'
      )
      .map(([id, card]) => {
        const { comment, productCode } =
          (card.policy as PolicyHealth) || ({} as any);
        const tronId = `${productCode}${
          comment === 'GRUPO' ? 9 : 2
        }${id}`.padStart(13, '0');
        return [tronId, card];
      })
      .reduce(fromEntriesArr, {});

    return {
      ...productCards,
      ...healthProductCardsWithTRONId
    };
  }

  private getDocumentTypeName(documentType: 'contract' | 'summary' | 'receipt') {
    switch (documentType) {
      case 'contract': return 'contrato';
      case 'summary': return 'resumen actual';
      case 'receipt': return 'justificante';
      default: return '';
    }
  }
}
